/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, {Component} from 'react';
import PropTypes from "prop-types";
import Svg from "../../../widgets/Svg/Svg";

export class AddContentComponent extends Component {
    static get propTypes() {
        return {
            addToCollection: PropTypes.func.isRequired,
            selectedChapterResources: PropTypes.array,
            cbeContentSearch: PropTypes.func.isRequired,
            closeModal: PropTypes.func.isRequired,
            activeCollection: PropTypes.object,
            searchResults: PropTypes.object,
            resetSearchData: PropTypes.func
        };

    }
    constructor(props){
        super();
        this.state = {
            pageNumber: 1,
            pageSize: 10,
            isbn: '',
            author: '',
            title: '',
            collectionId: '',
            selectedResourceIds: [],
            insertAfter: props.selectedChapterResources.length ? props.selectedChapterResources.length : 0
        };
        
        this.renderRows = this.renderRows.bind(this);
        this.openPDF = this.openPDF.bind(this);
        this.handleViewPDFClick = this.handleViewPDFClick.bind(this);
    }

    componentWillUnmount(){
        this.props.resetSearchData();
    }



    addRemoveResourceIds = (evt) => {
        const value = evt.currentTarget.value;
        const newSelectedResources = [...this.state.selectedResourceIds];
        const resIndex = newSelectedResources.indexOf(value);
        const isInList = resIndex >-1;
        const checked = evt.currentTarget.checked;

        if(checked && !isInList){
            //Add Resource
            this.setState({selectedResourceIds: [...newSelectedResources,value]});
        }
        if(!checked && isInList){
            //Remove Resource
            newSelectedResources.splice(resIndex, 1);
            this.setState({selectedResourceIds: [...newSelectedResources]});
        }

    };

    loadMore = (evt) =>{
        this.setNextPageNumber();
        // Do the search
        this.search(evt,{resetResult: false});

    };

    setNextPageNumber= () => {
        this.setState({pageNumber: this.state.pageNumber+1});
    };

    resetPageNumber = () => {
        this.setState({pageNumber: 1});
    };

    search = (evt,params = {resetResult: true}) =>{

        if(params.resetResult){
            this.resetPageNumber();
        }

        setTimeout(()=>{
            const {pageNumber,pageSize,isbn,author,title} = this.state;
            const cbeSearchObj = {
                pageNumber:pageNumber,
                pageSize: pageSize,
                isbn: isbn,
                author: author,
                title: title,
                collectionId: this.props.activeCollection.collectionId,
                resetResult: params.resetResult,
                activeCollection: this.props.activeCollection
            };
            this.props.cbeContentSearch(cbeSearchObj);
        },300);

    };
    isResourceAlreadyAdded = (resourceId) =>{

        if(this.props.activeCollection.resourceIds){
            return (this.props.activeCollection.resourceIds.indexOf(resourceId) > -1);
        }
        return false;
    };
    insertAfterChange = (evt)=> {
        const resCount = this.props.selectedChapterResources.length;
        const instAfterVal = (evt.currentTarget.value === '' || (evt.currentTarget.value <= resCount) && (evt.currentTarget.value>-1))? evt.currentTarget.value: resCount;
        this.setState({insertAfter: instAfterVal});
    };
    validateInsertAfter = (evt) => {
        if(this.state.insertAfter.trim() === ''){
            this.setState({insertAfter: 0});
        }
    };

    changeHandler = (evt) =>{
        const evtValue = evt.currentTarget.value;

        switch(evt.currentTarget.id){
            case 'searchTitle':
                this.setState({title: evtValue});
                break;
            case 'searchIsbn':
                this.setState({isbn: evtValue});
                break;
            case 'searchAuthor':
                this.setState({author: evtValue});
                break;
        }

    };
  
    handleViewPDFClick (event) {
        const resourceId = event.currentTarget.value;
        this.props.fetchPDFURL(resourceId);
    }
  
    openPDF (pdfURL) {
        this.props.resetPDFURL();
        const win = window.open(pdfURL, '_blank');
        win.focus();
    }
    
    renderRows(searchResults) {
        const {isPDFURLLoading} = this.props.resourceSearchResult;
        return searchResults.map((resource,index) =>{
            const isSelectedItem =searchResults.indexOf(resource.resourceId) > -1 ;
            const RESOURCE_ALREADY_NOT_ADDED = !this.isResourceAlreadyAdded(resource.resourceId);

            return (<div className={isSelectedItem? "row selected" : RESOURCE_ALREADY_NOT_ADDED? "row" : "row inactive"} key={index}>
                <div className={"coloumn"}>{RESOURCE_ALREADY_NOT_ADDED ? <input  onChange={this.addRemoveResourceIds} type='checkbox' value={resource.resourceId}/> : <input type='checkbox' disabled/>}</div>
                <div className="coloumn">{resource.parentISBN}</div>
                <div className="coloumn">{resource.title}</div>
                <div className="coloumn">{resource.authors}</div>
                <div className="coloumn">{resource.resourceInfo.pageCount}</div>
                <div className="coloumn">${resource.price}</div>
                <div className="coloumn">
                    <button
                        disabled={isPDFURLLoading && isPDFURLLoading !== '' || !RESOURCE_ALREADY_NOT_ADDED}
                        className={!(isPDFURLLoading && isPDFURLLoading !== '') ? "viewPdfBtn": "viewPdfBtn disabledBtn" }
                        value={resource.resourceId}  onClick={this.handleViewPDFClick} >
                        { !(isPDFURLLoading && isPDFURLLoading === resource.resourceId) ? "View PDF" : "Loading..." }
                    </button>
                </div>
            </div>);
        });
    }
    
    render(){
        const {addToCollection} = this.props;
        const {searchResults, activeResourcePDFURL} = this.props.resourceSearchResult;
        const {selectedResourceIds,title,isbn,author} = this.state;
        const activateSearch =title.length > 0 || isbn.length || author.length;
        return(<div className="add-content-component">
            <div className='black-overlay'>
                <div className="add-content">
                    <div className="add-content-header">
                        <h3 className="title-header">Add Content</h3>
                        <div className="close-cross" onClick={this.props.closeModal}><Svg svgString={'remove-sm-18'}></Svg></div>
                    </div>
                    <div className="add-content-body">
                        <div className="search-area">
                            <div className='row'>
                                <div className="coloumn">
                                    <input type="text" className="pe-textInput--basic" placeholder="Search by title, ISBN or author" id="searchTitle" value={title} onChange={this.changeHandler}/>
                                </div>
                                <div className="coloumn">
                                    {activateSearch ? <button type="button" className="pe-btn pe-btn__primary search-btn" onClick={this.search}>Search</button> : <button type="button" className="pe-btn pe-btn__primary search-btn" disabled>Search</button>}
                                </div>
                            </div>
                        </div>
                        <div className='result-table-wrapper'>
                            <div className="result-table">
                                <div className='row'>
                                    <div className="coloumn table-header">Select</div>
                                    <div className="coloumn table-header">ISBN/Course Catalog</div>
                                    <div className="coloumn table-header">Title</div>
                                    <div className="coloumn table-header">Author</div>
                                    <div className="coloumn table-header">Pages</div>
                                    <div className="coloumn table-header">Price</div>
                                    <div className="coloumn table-header">PDF</div>
                                </div>

                                {searchResults && searchResults.result && searchResults.result.length>0 && this.renderRows(searchResults.result)}
                                {activeResourcePDFURL && activeResourcePDFURL !== '' && this.openPDF(activeResourcePDFURL)}
                            </div>
                        </div>
                    </div>
                    <div className="add-content-footer">
                        <div className="insert-after-wrapper">
                            <label>Insert After : </label>
                            <input
                                className="pe-textInput--basic insert-after-text-box"
                                type="text"
                                value={this.state.insertAfter}
                                onChange={this.insertAfterChange}
                                onBlur={this.validateInsertAfter}
                            />
                        </div>
                        <div className="button-wrappers">
                            <button type="button" className="pe-btn--btn_small close-btn" onClick={this.props.closeModal}>Close</button>
                            {selectedResourceIds.length > 0 ? <button className="pe-btn pe-btn__primary" onClick={()=>{addToCollection(this.state.selectedResourceIds,this.state.insertAfter-1);}}>Add</button> : <button className="pe-btn pe-btn__primary" disabled>Add</button>}

                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/AddContentComponent.js